import type { NewAuditForm } from "./types";

// ─── Trigger Options ───────────────────────────────────────────────────────

export const TRIGGER_OPTIONS = [
  "Regulatory",
  "Certification",
  "Internal",
  "Ad-hoc",
] as const;

// ─── Default Form Values ───────────────────────────────────────────────────

export function getDefaultFormValues(): NewAuditForm {
  return {
    templateId: "",
    displayName: "",
    description: "",
    trigger: "",
    deadline: "",
    tagIds: [],
    auditorRequestText: "",
    notes: "",
    checklistSource: null,
  };
}
